module.exports = __webpack_public_path__ + "img/chamado.7996007e.png";